import {gte} from 'lodash';

export const percentDifference = (value: any, newValue: any) => {
  return parseFloat((((value - newValue) / newValue) * 100).toFixed(1));
};

export const getNumberCapper = (maxValue: any) => (num: any) => {
  return gte(num, maxValue) ? maxValue : num;
};

/**
 * This function sums the total value of a particular key/value in an array.
 * i.e, for arr = [{a:'1', b: '2'}, {a:'3', b: '4'}], sumKey(arr, 'b') = 2 + 4 = 6
 * @param {array} arr - array with values you want to sum.
 * @param {string} key - key of the values you want to sum in object
 * @returns {number} - sum of total values of key in array
 */
export const sumKey = function (arr: any, key: any) {
  return arr?.reduce(function (a: any, b: any) {
    // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    return parseFloat(Number(a) + Number(b[key])).toFixed(2);
  }, 0);
};
